import { createRouter, createWebHistory } from "vue-router";
import { useLoginStore } from "../stores/login/loginStore";
import Redirect from "../views/Redirect.vue";
import HomeVue from "../views/Home.vue";
import NotFound from "../views/NotFound.vue";
import FormClient from "../views/formClient.vue";
import Coupon from "../views/coupon.vue";
import { trackRouter } from "vue-gtag-next";

const routes = [
    { path: "/", redirect: { name: "Redirect" } },
    {
        path: "/redirect",
        name: "Redirect",
        component: Redirect,
    },
    { path: "/home", name: "Home", component: HomeVue },
    {
        path: "/home/:idCampaing",
        name: "Home",
        component: HomeVue,
        meta: { requiresAuth: false },
    },
    { path: "/datos", name: "FormCliente", component: FormClient },
    { path: "/cupon", name: "Cupon", component: Coupon },
    { path: "/:pathMatch(.*)*", component: NotFound },
];

const router = createRouter({
    history: createWebHistory("/"),
    routes,
});

/** Usamos este interceptor de manera global cara vez que exista un cambio de ruta
 * para validar si el usuario tiene acceso a esta ruta.
 */
router.beforeEach((to, _from, next) => {
    // Global guard
    const loginstore = useLoginStore();
    // const brand = localStorage.getItem("brand") as string;
    loginstore.defineTheme(import.meta.env.VITE_BRAND);
    if (to.matched.some((record) => record.meta.requiresAuth)) {
        // esta ruta requiere autenticación, verifique si inició sesión
        // si no, redirigir a la página de inicio de sesión.
        if (localStorage.getItem("logout") !== "false") {
            next({ name: "Login" });
        } else {
            next(); // ir a donde sea que vaya
        }
    } else {
        next(); // no requiere autenticación,
    }
});

trackRouter(router);

export default router;
